import { ApprovedStateTypeEnumSchema } from "@/Enums/ApprovedStateType";
import { z } from "zod";

export const MyReportsDtoSchema = z.object({
    id: z.number(),
    name: z.string(),
    description: z.string(),
    icon: z.string(),
    iconColor: z.string(),
    isPeriodicReport: z.boolean(),
    approvedState: ApprovedStateTypeEnumSchema.nullish(),
});

export type MyReportsDto = z.infer<typeof MyReportsDtoSchema>;